/* eslint-disable import/prefer-default-export */

import React from 'react';

const pdfIcon = (): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
    <path
      d="M3.53333 0.26001H16.4667C18.4 0.26001 20 1.86001 20 3.79334V16.1933C20 18.16 18.4 19.7267 16.4667 19.7267H3.53333C1.6 19.76 0 18.16 0 16.2267V3.79334C0 1.86001 1.6 0.26001 3.53333 0.26001Z"
      fill="#B30B00"
    />
    <path
      d="M16.0666 11.56C15.6666 11.1267 14.8999 10.9267 13.7999 10.9267C13.1999 10.9267 12.5666 10.9933 11.9666 11.0933C11.5666 10.7267 11.2333 10.2933 10.8999 9.86001C10.6666 9.52667 10.4333 9.19334 10.2333 8.82667C10.5666 7.89334 10.7666 6.89334 10.8333 5.89334C10.8333 4.99334 10.4666 4.02667 9.4666 4.02667C9.13327 4.02667 8.79994 4.22667 8.63327 4.52667C8.19994 5.26001 8.3666 6.76001 9.0666 8.32667C8.83327 9.02667 8.5666 9.72667 8.2666 10.4933C7.99994 11.16 7.69994 11.7933 7.33327 12.3933C6.29994 12.7933 4.13327 13.7933 3.93327 14.8933C3.8666 15.2267 3.9666 15.56 4.23327 15.76C4.4666 15.96 4.79994 16.0933 5.13327 16.06C6.43327 16.06 7.73327 14.26 8.63327 12.6933C9.13327 12.5267 9.63327 12.36 10.1666 12.2267C10.7333 12.0933 11.2666 11.96 11.7666 11.86C13.1666 13.06 14.3999 13.26 14.9999 13.26C15.8333 13.26 16.1666 12.8933 16.2666 12.5933C16.3999 12.2267 16.3333 11.8267 16.0666 11.56V11.56ZM15.1666 12.1933C15.1333 12.4267 14.8666 12.5933 14.5333 12.5933C14.4333 12.5933 14.3333 12.5933 14.2333 12.56C13.5666 12.3933 12.9333 12.06 12.3999 11.6267C12.8333 11.56 13.2999 11.5267 13.7333 11.5267C14.0333 11.5267 14.3333 11.56 14.6333 11.5933C14.9333 11.66 15.2666 11.7933 15.1666 12.1933V12.1933ZM9.19994 4.82667C9.2666 4.72667 9.3666 4.66001 9.49994 4.62667C9.83327 4.62667 9.89994 4.99334 9.89994 5.32667C9.8666 6.09334 9.73327 6.82667 9.49994 7.56001C8.93327 6.12667 8.99994 5.16001 9.19994 4.82667ZM11.0666 11.2267C10.6999 11.2933 10.3333 11.3933 9.9666 11.4933C9.69994 11.56 9.43327 11.66 9.13327 11.7267C9.2666 11.4267 9.39994 11.1267 9.53327 10.86C9.69994 10.4933 9.83327 10.1267 9.9666 9.76001C10.0999 9.96001 10.1999 10.1267 10.3333 10.2933C10.5666 10.6267 10.8333 10.9267 11.0666 11.2267ZM7.03327 13.16C6.19994 14.4933 5.3666 15.36 4.89994 15.36C4.83327 15.36 4.73327 15.3267 4.69994 15.2933C4.59994 15.2267 4.5666 15.0933 4.59994 14.9933C4.6666 14.4933 5.63327 13.7933 7.03327 13.16Z"
      fill="white"
    />
  </svg>
);

const excelIcon = (): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
    <path
      d="M12.5581 9.53721L4.65115 8.14186V18.4521C4.65115 18.9229 5.03285 19.3047 5.50371 19.3047H19.1474C19.6183 19.3047 20 18.9229 20 18.4521V14.6535L12.5581 9.53721Z"
      fill="#185C37"
    />
    <path
      d="M12.5581 0.699997H5.50371C5.03285 0.699997 4.65115 1.0817 4.65115 1.55255V5.35116L12.5581 10.0023L16.7442 11.3977L20 10.0023V5.35116L12.5581 0.699997Z"
      fill="#21A366"
    />
    <path d="M4.65115 5.35117H12.5581V10.0023H4.65115V5.35117Z" fill="#107C41" />
    <path
      opacity="0.1"
      d="M10.3102 4.42093H4.65115V16.0488H10.3102C10.7804 16.0473 11.1613 15.6665 11.1628 15.1963V5.27348C11.1613 4.80327 10.7804 4.42246 10.3102 4.42093Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M9.84511 4.88605H4.65115V16.514H9.84511C10.3153 16.5124 10.6961 16.1316 10.6977 15.6614V5.7386C10.6961 5.26839 10.3153 4.88758 9.84511 4.88605Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M9.84511 4.88605H4.65115V15.5837H9.84511C10.3153 15.5822 10.6961 15.2014 10.6977 14.7312V5.7386C10.6961 5.26839 10.3153 4.88758 9.84511 4.88605Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M9.37999 4.88605H4.65115V15.5837H9.37999C9.85021 15.5822 10.231 15.2014 10.2325 14.7312V5.7386C10.231 5.26839 9.85021 4.88758 9.37999 4.88605Z"
      fill="black"
    />
    <path
      d="M0.852556 4.88605H9.37999C9.85085 4.88605 10.2325 5.26775 10.2325 5.7386V14.266C10.2325 14.7369 9.85085 15.1186 9.37999 15.1186H0.852556C0.381701 15.1186 0 14.7369 0 14.266V5.7386C0 5.26775 0.381701 4.88605 0.852556 4.88605Z"
      fill="url(#paint0_linear_1251_1676)"
    />
    <path
      d="M2.64047 12.7735L4.43396 9.99442L2.79071 7.2307H4.11256L5.00931 8.99814C5.0921 9.16604 5.14884 9.2907 5.17954 9.37302H5.19117C5.24914 9.24105 5.31118 9.11091 5.37722 8.98278L6.33582 7.23163H7.54931L5.86419 9.97908L7.59211 12.7735H6.30094L5.26513 10.8335C5.21633 10.7509 5.17493 10.6643 5.14141 10.5744H5.12606C5.09572 10.6624 5.05546 10.7467 5.00606 10.8256L3.93955 12.7735H2.64047Z"
      fill="white"
    />
    <path
      d="M19.1474 0.699997H12.5581V5.35116H20V1.55255C20 1.0817 19.6183 0.699997 19.1474 0.699997Z"
      fill="#33C481"
    />
    <path d="M12.5581 10.0023H20V14.6535H12.5581V10.0023Z" fill="#107C41" />
    <defs>
      <linearGradient
        id="paint0_linear_1251_1676"
        x1="1.7776"
        y1="4.21988"
        x2="8.45496"
        y2="15.7848"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#18884F" />
        <stop offset="0.5" stopColor="#117E43" />
        <stop offset="1" stopColor="#0B6631" />
      </linearGradient>
    </defs>
  </svg>
);

const imageIcon = (): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
    <path
      d="M19.0913 0H0.908971C0.363559 0 0 0.36355 0 0.908971V19.0908C0 19.6362 0.36355 20 0.909166 20H19.091C19.6364 20 20.0002 19.6365 20.0002 19.0908L20 0.908971C20 0.363559 19.6365 0 19.091 0H19.0913ZM6.36358 3.63628C7.36367 3.63628 8.18172 4.45452 8.18172 5.45441C8.18172 6.45451 7.36348 7.27255 6.36358 7.27255C5.36349 7.27255 4.54544 6.45431 4.54544 5.45441C4.54544 4.45452 5.36368 3.63628 6.36358 3.63628ZM10 17.0911H2.7274L6.27294 12.8183C6.54575 12.4548 7.18211 12.3638 7.54567 12.7274L9.09117 14.0001L11.364 10.091C11.9094 9.18185 12.7276 9.18185 13.1821 10.091L17.2731 17.182L9.99995 17.1818L10 17.0911Z"
      fill="black"
    />
  </svg>
);

const textFileIcon = (): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
    <path
      d="M14.6315 4.82077H5.36845C4.84214 4.82077 4.39996 5.26295 4.39996 5.78926C4.39996 6.31557 4.84214 6.75775 5.36845 6.75775H14.6315C15.1579 6.75775 15.6 6.31557 15.6 5.78926C15.6 5.26295 15.1579 4.82077 14.6315 4.82077Z"
      fill="black"
    />
    <path
      d="M14.6315 9.03156H5.36845C4.84214 9.03156 4.39996 9.47373 4.39996 10C4.39996 10.5264 4.84214 10.9685 5.36845 10.9685H14.6315C15.1579 10.9685 15.6 10.5264 15.6 10C15.6 9.47373 15.1579 9.03156 14.6315 9.03156Z"
      fill="black"
    />
    <path
      d="M11.6 13.2419H5.36845C4.84214 13.2419 4.39996 13.684 4.39996 14.2104C4.39996 14.7367 4.84214 15.1788 5.36845 15.1788H11.5789C12.1052 15.1788 12.5474 14.7367 12.5474 14.2104C12.5684 13.663 12.1263 13.2419 11.5999 13.2419H11.6Z"
      fill="black"
    />
    <path
      d="M16.6947 0.399994H3.30531C1.47379 0.399994 0 1.87363 0 3.70531V16.2947C0 18.1262 1.47364 19.6 3.30531 19.6H16.6947C18.5262 19.6 20 18.1264 20 16.2947L19.9999 3.70531C19.9999 1.87378 18.5262 0.400144 16.6945 0.400144L16.6947 0.399994ZM18.0632 16.2946C18.0632 17.0525 17.4527 17.6629 16.6948 17.6629H3.30546C2.54757 17.6629 1.93713 17.0525 1.93713 16.2946L1.93698 3.70523C1.93698 2.94734 2.54743 2.3369 3.30532 2.3369H16.6947C17.4526 2.3369 18.063 2.94734 18.063 3.70523L18.0632 16.2946Z"
      fill="black"
    />
  </svg>
);

const powerPointFileIcon = (): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
    <path
      d="M12.093 10.9326L10.6976 0.700012H10.5935C5.51962 0.714825 1.41014 4.82431 1.39532 9.89815V10.0023L12.093 10.9326Z"
      fill="#ED6C47"
    />
    <path
      d="M10.8019 0.700012H10.6977V10.0023L15.3489 11.8628L20 10.0023V9.89815C19.9852 4.82431 15.8757 0.714825 10.8019 0.700012Z"
      fill="#FF8F6B"
    />
    <path
      d="M20 10.0023V10.1047C19.9854 15.1796 15.875 19.2901 10.8 19.3047H10.5953C5.52035 19.2901 1.40989 15.1796 1.39532 10.1047V10.0023H20Z"
      fill="#D35230"
    />
    <path
      opacity="0.1"
      d="M11.1628 5.2721V15.1977C11.1605 15.5426 10.9515 15.8524 10.6325 15.9837C10.531 16.0267 10.4219 16.0488 10.3116 16.0488H3.59068C3.46045 15.9 3.33488 15.7419 3.21859 15.5837C2.03361 14.003 1.39379 12.0802 1.39534 10.1047V9.9C1.39262 8.11806 1.9134 6.37457 2.89301 4.88605C2.99534 4.72791 3.10231 4.56977 3.21859 4.42093H10.3116C10.7802 4.42448 11.1592 4.80349 11.1628 5.2721V5.2721Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M10.6977 5.73722V15.6628C10.6977 15.7731 10.6755 15.8822 10.6326 15.9837C10.5012 16.3026 10.1914 16.5116 9.8465 16.514H4.01395C3.86678 16.3646 3.72559 16.2094 3.59068 16.0488C3.46045 15.9 3.33488 15.7419 3.21859 15.5837C2.03361 14.003 1.3938 12.0802 1.39534 10.1047V9.9C1.39262 8.11806 1.9134 6.37457 2.89301 4.88605H9.8465C10.3151 4.88959 10.6941 5.2686 10.6977 5.73722Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M10.6977 5.73724V14.7326C10.6941 15.2012 10.3151 15.5802 9.8465 15.5838H3.21859C2.03361 14.003 1.3938 12.0803 1.39534 10.1047V9.90003C1.39262 8.11809 1.9134 6.3746 2.89301 4.88608H9.84649C10.3151 4.88961 10.6941 5.26862 10.6977 5.73724Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M10.2325 5.73724V14.7326C10.229 15.2012 9.84999 15.5802 9.38139 15.5838H3.21859C2.03361 14.003 1.3938 12.0803 1.39534 10.1047V9.90003C1.39262 8.11809 1.9134 6.3746 2.89301 4.88608H9.38138C9.84999 4.88961 10.229 5.26862 10.2325 5.73724V5.73724Z"
      fill="black"
    />
    <path
      d="M0.852553 4.88605H9.37999C9.85085 4.88605 10.2325 5.26776 10.2325 5.7386V14.266C10.2325 14.7369 9.85084 15.1186 9.37999 15.1186H0.852553C0.381708 15.1186 0 14.7369 0 14.2661V5.7386C0 5.26776 0.381708 4.88605 0.852553 4.88605V4.88605Z"
      fill="url(#paint0_linear_1251_1681)"
    />
    <path
      d="M5.20927 7.16001C5.76438 7.12256 6.31471 7.2838 6.76183 7.6149C6.94589 7.77922 7.09018 7.98322 7.18381 8.2115C7.27744 8.43977 7.31796 8.68634 7.3023 8.93257C7.30839 9.27939 7.21598 9.62082 7.03579 9.91722C6.85337 10.2085 6.59055 10.4408 6.27904 10.5861C5.92292 10.7517 5.53356 10.8335 5.1409 10.8251H4.0623V12.8298H2.95764V7.16001H5.20927ZM4.06137 9.95909H5.01207C5.31347 9.98122 5.61252 9.89202 5.85254 9.70839C5.95061 9.61431 6.02688 9.49989 6.07598 9.37317C6.12508 9.24644 6.14581 9.1105 6.13672 8.97491C6.13672 8.3501 5.77362 8.03769 5.04743 8.03769H4.06138V9.95909H4.06137Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1251_1681"
        x1="1.7776"
        y1="4.21987"
        x2="8.45496"
        y2="15.7848"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CA4C28" />
        <stop offset="0.5" stopColor="#C5401E" />
        <stop offset="1" stopColor="#B62F14" />
      </linearGradient>
    </defs>
  </svg>
);

const unssuportedFileIcon = (): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
    <path
      d="M10 0.000512011C4.48631 0.000512011 0 4.48687 0 10.0015C0 15.5163 4.48636 20 10 20C15.5136 20 20 15.5149 20 10C20 4.48513 15.5136 0 10 0V0.000512011ZM10 18.1822C5.48866 18.1822 1.81828 14.5117 1.81828 10.0005C1.81828 5.48928 5.48876 1.81879 10 1.81879C14.5112 1.81879 18.1817 5.48928 18.1817 10.0005C18.1817 14.5117 14.5112 18.1822 10 18.1822Z"
      fill="black"
    />
    <path
      d="M7.27309 10.0004C7.27309 10.5025 6.86617 10.9095 6.36405 10.9095C5.86215 10.9095 5.45502 10.5025 5.45502 10.0004C5.45502 9.49831 5.86214 9.09138 6.36405 9.09138C6.86616 9.09138 7.27309 9.49831 7.27309 10.0004Z"
      fill="black"
    />
    <path
      d="M10.9091 10.0004C10.9091 10.5025 10.5022 10.9095 10.0001 10.9095C9.49799 10.9095 9.09106 10.5025 9.09106 10.0004C9.09106 9.49831 9.49799 9.09138 10.0001 9.09138C10.5022 9.09138 10.9091 9.49831 10.9091 10.0004Z"
      fill="black"
    />
    <path
      d="M14.5452 10.0004C14.5452 10.5025 14.1381 10.9095 13.6361 10.9095C13.134 10.9095 12.7271 10.5025 12.7271 10.0004C12.7271 9.49831 13.134 9.09138 13.6361 9.09138C14.1381 9.09138 14.5452 9.49831 14.5452 10.0004Z"
      fill="black"
    />
  </svg>
);

const msgFileIcon = (): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
    <path
      d="M20 10.4674C20.0005 10.3906 19.9812 10.3148 19.9438 10.2476C19.9065 10.1804 19.8525 10.1239 19.7869 10.0837H19.7846L19.7762 10.0791L12.846 5.97675C12.8161 5.95653 12.785 5.93805 12.753 5.92141C12.6211 5.85337 12.4749 5.81787 12.3265 5.81787C12.1781 5.81787 12.0318 5.85337 11.8999 5.92141C11.8679 5.93806 11.8368 5.95654 11.8069 5.97675L4.87671 10.0791L4.86835 10.0837C4.65654 10.2154 4.5916 10.4939 4.72332 10.7057C4.76213 10.7681 4.81558 10.8201 4.87904 10.8572L11.8093 14.9595C11.8393 14.9796 11.8704 14.9981 11.9023 15.0149C12.0342 15.0829 12.1804 15.1184 12.3288 15.1184C12.4772 15.1184 12.6234 15.0829 12.7553 15.0149C12.7873 14.9981 12.8183 14.9796 12.8483 14.9595L19.7786 10.8572C19.8466 10.8176 19.9029 10.7606 19.9418 10.6922C19.9807 10.6237 20.0007 10.5462 20 10.4674V10.4674Z"
      fill="#0A2767"
    />
    <path
      d="M5.68466 7.72838H10.2326V11.8972H5.68466V7.72838ZM19.0698 3.49071V1.58373C19.0807 1.10694 18.7033 0.711437 18.2265 0.700012H6.42467C5.94788 0.711437 5.57049 1.10694 5.58141 1.58373V3.49071L12.5581 5.35117L19.0698 3.49071Z"
      fill="#0364B8"
    />
    <path d="M5.58136 3.49069H10.2325V7.67673H5.58136V3.49069Z" fill="#0078D4" />
    <path
      d="M14.8837 3.49069H10.2325V7.67673L14.8837 11.8628H19.0698V7.67673L14.8837 3.49069Z"
      fill="#28A8EA"
    />
    <path d="M10.2325 7.67676H14.8837V11.8628H10.2325V7.67676Z" fill="#0078D4" />
    <path d="M10.2325 11.8628H14.8837V16.0488H10.2325V11.8628Z" fill="#0364B8" />
    <path d="M5.68463 11.8972H10.2325V15.687H5.68463V11.8972Z" fill="#14447D" />
    <path d="M14.8837 11.8628H19.0698V16.0488H14.8837V11.8628Z" fill="#0078D4" />
    <path
      d="M19.787 10.8316L19.7781 10.8363L12.8479 14.7339C12.8177 14.7525 12.787 14.7702 12.7549 14.786C12.6372 14.8421 12.5093 14.8737 12.3791 14.8791L12.0005 14.6577C11.9685 14.6416 11.9374 14.6237 11.9075 14.6042L4.8842 10.5958H4.88095L4.65118 10.4674V18.3577C4.65477 18.8841 5.08429 19.308 5.61071 19.3046H19.0554C19.0633 19.3046 19.0702 19.3009 19.0786 19.3009C19.1898 19.2938 19.2994 19.2709 19.4042 19.233C19.4495 19.2138 19.4932 19.1911 19.5349 19.1651C19.566 19.1474 19.6195 19.1088 19.6195 19.1088C19.737 19.0219 19.8326 18.9087 19.8987 18.7783C19.9647 18.6479 19.9994 18.5039 20 18.3577V10.4674C19.9999 10.5416 19.9802 10.6143 19.9427 10.6783C19.9053 10.7423 19.8516 10.7952 19.787 10.8316V10.8316Z"
      fill="url(#paint0_linear_1251_1680)"
    />
    <path
      opacity="0.5"
      d="M19.6279 10.4363V10.92L12.3814 15.9093L4.87906 10.5991C4.87906 10.5978 4.87857 10.5966 4.87769 10.5958C4.87682 10.5949 4.87564 10.5944 4.8744 10.5944L4.18604 10.1805V9.83162L4.46976 9.82697L5.06975 10.1712L5.0837 10.1758L5.13486 10.2084C5.13486 10.2084 12.186 14.2316 12.2046 14.2409L12.4744 14.3991C12.4976 14.3897 12.5209 14.3805 12.5488 14.3711C12.5628 14.3618 19.5488 10.4316 19.5488 10.4316L19.6279 10.4363Z"
      fill="#0A2767"
    />
    <path
      d="M19.787 10.8316L19.7781 10.8367L12.8479 14.7344C12.8177 14.753 12.787 14.7707 12.7549 14.7865C12.6221 14.8514 12.4762 14.8851 12.3284 14.8851C12.1805 14.8851 12.0347 14.8514 11.9019 14.7865C11.87 14.7707 11.8389 14.7533 11.8088 14.7344L4.87862 10.8367L4.87026 10.8316C4.80456 10.796 4.74959 10.7434 4.71107 10.6794C4.67254 10.6154 4.65187 10.5422 4.65118 10.4674V18.3577C4.65452 18.884 5.08389 19.308 5.61021 19.3046H19.0409C19.5673 19.308 19.9967 18.884 20 18.3577C20 18.3577 20 18.3577 20 18.3577V10.4674C19.9999 10.5416 19.9802 10.6143 19.9427 10.6783C19.9053 10.7423 19.8515 10.7952 19.787 10.8316V10.8316Z"
      fill="#1490DF"
    />
    <path
      opacity="0.1"
      d="M12.9488 14.6767L12.8451 14.7349C12.815 14.754 12.784 14.7716 12.752 14.7874C12.6378 14.8435 12.5135 14.8764 12.3865 14.8842L15.0232 18.0023L19.6228 19.1107C19.7488 19.0155 19.849 18.8903 19.9144 18.7465L12.9488 14.6767Z"
      fill="black"
    />
    <path
      opacity="0.05"
      d="M13.4186 14.4126L12.8451 14.7349C12.815 14.754 12.784 14.7716 12.752 14.7874C12.6378 14.8435 12.5135 14.8764 12.3865 14.8842L13.6218 18.2902L19.6241 19.1093C19.7408 19.0217 19.8354 18.9082 19.9007 18.7778C19.9659 18.6473 19.9999 18.5035 19.9999 18.3577V18.2558L13.4186 14.4126Z"
      fill="black"
    />
    <path
      d="M5.62327 19.3046H19.0395C19.246 19.3057 19.4473 19.2405 19.614 19.1186L12 14.6586C11.968 14.6425 11.937 14.6247 11.907 14.6051L4.88374 10.5967H4.88048L4.65118 10.4674V18.3307C4.65066 18.8681 5.08588 19.3041 5.62327 19.3046C5.62326 19.3046 5.62326 19.3046 5.62327 19.3046Z"
      fill="#28A8EA"
    />
    <path
      opacity="0.1"
      d="M11.1628 5.27348V15.1944C11.162 15.5422 10.9505 15.8549 10.6279 15.9851C10.528 16.028 10.4204 16.0502 10.3116 16.0502H4.65118V4.88604H5.58142V4.42093H10.3117C10.7815 4.42271 11.1618 4.8036 11.1628 5.27348V5.27348Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M10.6977 5.73861V15.6595C10.6989 15.7719 10.675 15.8831 10.6279 15.9851C10.4988 16.3035 10.1901 16.5124 9.84653 16.5139H4.65118V4.88606H9.84653C9.98149 4.88471 10.1145 4.91836 10.2326 4.98374C10.5177 5.12738 10.6976 5.41936 10.6977 5.73861V5.73861Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M10.6977 5.73861V14.7293C10.6954 15.199 10.3162 15.5796 9.84654 15.5837H4.65118V4.88606H9.84653C9.98149 4.88471 10.1145 4.91836 10.2326 4.98374C10.5177 5.12738 10.6976 5.41936 10.6977 5.73861V5.73861Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M10.2326 5.7386V14.7293C10.2321 15.1997 9.85181 15.5814 9.38142 15.5837H4.65118V4.88605H9.38141C9.85175 4.8863 10.2328 5.2678 10.2326 5.73814C10.2326 5.7383 10.2326 5.73845 10.2326 5.7386V5.7386Z"
      fill="black"
    />
    <path
      d="M0.852555 4.88605H9.37999C9.85085 4.88605 10.2325 5.26776 10.2325 5.7386V14.266C10.2325 14.7369 9.85085 15.1186 9.37999 15.1186H0.852555C0.381697 15.1186 0 14.7369 0 14.266V5.7386C0 5.26776 0.381708 4.88605 0.852555 4.88605Z"
      fill="url(#paint1_linear_1251_1680)"
    />
    <path
      d="M2.66462 8.46186C2.87474 8.01416 3.21392 7.63951 3.63858 7.38605C4.10887 7.1168 4.64434 6.98257 5.18602 6.99813C5.68808 6.98724 6.18347 7.11451 6.61812 7.36604C7.02677 7.60974 7.3559 7.96682 7.56555 8.39394C7.79388 8.86459 7.90767 9.38256 7.89765 9.90557C7.90872 10.4522 7.79164 10.9937 7.55579 11.487C7.34114 11.9294 7.00157 12.2992 6.57905 12.5507C6.12765 12.8099 5.61386 12.9405 5.09347 12.9284C4.58069 12.9407 4.07436 12.812 3.62975 12.5563C3.21756 12.3122 2.88429 11.9548 2.66975 11.5265C2.44007 11.0626 2.32492 10.5505 2.33393 10.033C2.32437 9.49106 2.43741 8.95396 2.66462 8.46186V8.46186ZM3.70276 10.9874C3.8148 11.2705 4.00478 11.5159 4.25067 11.6953C4.50111 11.8704 4.80101 11.9607 5.10648 11.953C5.43178 11.9659 5.75244 11.8725 6.01997 11.687C6.26274 11.5081 6.44774 11.262 6.55206 10.9791C6.66868 10.6631 6.72622 10.3284 6.72182 9.99162C6.72543 9.65163 6.67133 9.3135 6.56182 8.99162C6.4651 8.70101 6.28607 8.44474 6.04648 8.25395C5.78565 8.05963 5.46585 7.96108 5.14089 7.97488C4.82881 7.96679 4.5222 8.05781 4.26508 8.23488C4.01504 8.41505 3.82145 8.66268 3.70695 8.94882C3.45295 9.60471 3.45162 10.3316 3.70322 10.9884L3.70276 10.9874Z"
      fill="white"
    />
    <path d="M14.8837 3.49069H19.0698V7.67673H14.8837V3.49069Z" fill="#50D9FF" />
    <defs>
      <linearGradient
        id="paint0_linear_1251_1680"
        x1="12.3256"
        y1="10.4674"
        x2="12.3256"
        y2="19.3047"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#35B8F1" />
        <stop offset="1" stopColor="#28A8EA" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1251_1680"
        x1="1.7776"
        y1="4.21987"
        x2="8.45494"
        y2="15.7848"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1784D9" />
        <stop offset="0.5" stopColor="#107AD5" />
        <stop offset="1" stopColor="#0A63C9" />
      </linearGradient>
    </defs>
  </svg>
);

const docFileIcon = (): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
    <path
      d="M19.1474 0.700012H5.50371C5.03286 0.700012 4.65115 1.08172 4.65115 1.55257V5.35117L12.5581 7.67675L20 5.35117V1.55257C20 1.08172 19.6183 0.700012 19.1474 0.700012Z"
      fill="#41A5EE"
    />
    <path d="M20 5.35117H4.65115V10.0023L12.5581 11.3977L20 10.0023V5.35117Z" fill="#2B7CD3" />
    <path d="M4.65115 10.0023V14.6535L12.093 15.5837L20 14.6535V10.0023H4.65115Z" fill="#185ABD" />
    <path
      d="M5.50371 19.3046H19.1474C19.6183 19.3046 20 18.9229 20 18.4521V14.6535H4.65115V18.4521C4.65115 18.9229 5.03286 19.3046 5.50371 19.3046Z"
      fill="#103F91"
    />
    <path
      opacity="0.1"
      d="M10.3102 4.42093H4.65115V16.0488H10.3102C10.7804 16.0473 11.1612 15.6665 11.1628 15.1963V5.27349C11.1612 4.80327 10.7804 4.42246 10.3102 4.42093Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M9.8451 4.88605H4.65115V16.5139H9.8451C10.3153 16.5124 10.6961 16.1316 10.6977 15.6614V5.73861C10.6961 5.26839 10.3153 4.88758 9.8451 4.88605Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M9.8451 4.88605H4.65115V15.5837H9.8451C10.3153 15.5822 10.6961 15.2014 10.6977 14.7312V5.73861C10.6961 5.26839 10.3153 4.88758 9.8451 4.88605Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M9.37999 4.88605H4.65115V15.5837H9.37999C9.85021 15.5822 10.231 15.2014 10.2325 14.7312V5.73861C10.231 5.26839 9.85021 4.88758 9.37999 4.88605Z"
      fill="black"
    />
    <path
      d="M0.85256 4.88605H9.37999C9.85085 4.88605 10.2326 5.26775 10.2326 5.73861V14.2661C10.2326 14.7369 9.85085 15.1186 9.37999 15.1186H0.85256C0.381703 15.1186 0 14.7369 0 14.2661V5.73861C0 5.26775 0.381703 4.88605 0.85256 4.88605Z"
      fill="url(#paint0_linear_1251_1675)"
    />
    <path
      d="M3.4986 11.4247C3.51535 11.5563 3.52651 11.6707 3.53162 11.7688H3.55115C3.5586 11.6758 3.5741 11.5637 3.59767 11.4326C3.62124 11.3014 3.64248 11.1905 3.66139 11.1L4.55813 7.23117H5.71767L6.6479 11.0419C6.70195 11.2788 6.74064 11.519 6.76372 11.7609H6.77907C6.79641 11.5265 6.82873 11.2935 6.87581 11.0633L7.61767 7.22931H8.67302L7.36976 12.7735H6.13674L5.25302 9.10186C5.22744 8.99628 5.19814 8.85814 5.16605 8.68837C5.13395 8.5186 5.11395 8.39442 5.10605 8.31628H5.09069C5.08047 8.4065 5.06046 8.54047 5.03069 8.71814C5.00092 8.89582 4.97705 9.02728 4.95906 9.11256L4.12836 12.7726H2.8744L1.56418 7.23116H2.63859L3.4465 11.1079C3.46465 11.1874 3.48186 11.2935 3.4986 11.4247V11.4247Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1251_1675"
        x1="1.7776"
        y1="4.21987"
        x2="8.45495"
        y2="15.7848"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2368C4" />
        <stop offset="0.5" stopColor="#1A5DBE" />
        <stop offset="1" stopColor="#1146AC" />
      </linearGradient>
    </defs>
  </svg>
);

const csvIcon = (): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
    <rect width="20" height="20" rx="2" fill="#16B126" />
    <path
      d="M5.1648 13.62C4.61814 13.62 4.1148 13.4933 3.6548 13.24C3.1948 12.9867 2.8248 12.6133 2.5448 12.12C2.27147 11.62 2.1348 11.0067 2.1348 10.28C2.1348 9.56 2.2748 8.94667 2.5548 8.44C2.84147 7.92667 3.21814 7.53667 3.6848 7.27C4.15814 6.99667 4.66814 6.86 5.2148 6.86C5.6348 6.86 6.01147 6.94667 6.3448 7.12C6.67814 7.28667 6.9548 7.48333 7.1748 7.71L6.39481 8.65C6.22814 8.49667 6.05147 8.37333 5.8648 8.28C5.6848 8.18 5.47814 8.13 5.2448 8.13C4.95147 8.13 4.68147 8.21333 4.4348 8.38C4.1948 8.54667 4.00147 8.78667 3.8548 9.1C3.7148 9.41333 3.6448 9.79 3.6448 10.23C3.6448 10.8967 3.78814 11.4167 4.0748 11.79C4.36147 12.1633 4.7448 12.35 5.2248 12.35C5.49147 12.35 5.72814 12.29 5.9348 12.17C6.14814 12.05 6.3348 11.9067 6.4948 11.74L7.2748 12.66C6.72814 13.3 6.0248 13.62 5.1648 13.62ZM9.97191 13.62C9.54525 13.62 9.11858 13.54 8.69191 13.38C8.27191 13.22 7.89525 12.9867 7.56191 12.68L8.40191 11.67C8.63525 11.87 8.89525 12.0333 9.18191 12.16C9.46858 12.2867 9.74525 12.35 10.0119 12.35C10.3186 12.35 10.5452 12.2933 10.6919 12.18C10.8452 12.0667 10.9219 11.9133 10.9219 11.72C10.9219 11.5133 10.8352 11.3633 10.6619 11.27C10.4952 11.17 10.2686 11.06 9.98191 10.94L9.13191 10.58C8.91191 10.4867 8.70191 10.3633 8.50191 10.21C8.30191 10.05 8.13858 9.85333 8.01191 9.62C7.88525 9.38667 7.82191 9.11333 7.82191 8.8C7.82191 8.44 7.91858 8.11333 8.11191 7.82C8.31191 7.52667 8.58525 7.29333 8.93191 7.12C9.28525 6.94667 9.68858 6.86 10.1419 6.86C10.5152 6.86 10.8886 6.93333 11.2619 7.08C11.6352 7.22667 11.9619 7.44 12.2419 7.72L11.4919 8.65C11.2786 8.48333 11.0652 8.35667 10.8519 8.27C10.6386 8.17667 10.4019 8.13 10.1419 8.13C9.88858 8.13 9.68525 8.18333 9.53191 8.29C9.38525 8.39 9.31191 8.53333 9.31191 8.72C9.31191 8.92 9.40525 9.07 9.59191 9.17C9.78525 9.27 10.0219 9.37667 10.3019 9.49L11.1419 9.83C11.5352 9.99 11.8486 10.21 12.0819 10.49C12.3152 10.77 12.4319 11.14 12.4319 11.6C12.4319 11.96 12.3352 12.2933 12.1419 12.6C11.9486 12.9067 11.6686 13.1533 11.3019 13.34C10.9352 13.5267 10.4919 13.62 9.97191 13.62ZM14.6686 13.5L12.6986 6.98H14.2586L15.0386 10.02C15.1386 10.3733 15.2252 10.72 15.2986 11.06C15.3786 11.4 15.4686 11.75 15.5686 12.11H15.6086C15.7019 11.75 15.7886 11.4 15.8686 11.06C15.9486 10.72 16.0352 10.3733 16.1286 10.02L16.8986 6.98H18.3986L16.4386 13.5H14.6686Z"
      fill="white"
    />
  </svg>
);

const fileExtensionMap = [
  { icon: docFileIcon, extensions: ['doc', 'docx'] },
  { icon: excelIcon, extensions: ['xlsx', 'xls'] },
  { icon: powerPointFileIcon, extensions: ['ppt', 'pptx'] },
  { icon: pdfIcon, extensions: ['pdf'] },
  { icon: csvIcon, extensions: ['csv'] },
  { icon: imageIcon, extensions: ['jpg', 'jpeg', 'png', 'gif'] },
  { icon: msgFileIcon, extensions: ['msg'] },
  { icon: textFileIcon, extensions: ['txt', 'json', 'log', 'xml', 'rtf'] },
];

const fileExtensionIconParser = (extension: string): JSX.Element => {
  const icon = fileExtensionMap.find((f) => f.extensions.some((e) => e === extension))?.icon;

  if (icon) return icon();

  return unssuportedFileIcon();
};

export default fileExtensionIconParser;
